import httpCommon, { httpFormData } from "./http-common";

// Get all campaigns
const getAllCampaigns = (businessId: number) => {
  return httpCommon.get(`/v1/get/campaigns/${businessId}`);
};

// Get campaign by ID
const getCampaign = (campaignId: string) => {
  return httpCommon.get(`/v1/get/campaign/${campaignId}`);
};

// Get campaign stats
const getCampaignStats = (campaignId: string) => {
  return httpCommon.get(`/v1/get/campaign-stats/${campaignId}`);
};

// Create campaign
const createCampaign = (businessId: number, data: any, onUploadProgress?: (progressEvent: ProgressEvent) => void) => {
  // Check if data contains files and should use form-data
  if (data instanceof FormData) {
    return httpFormData.post(`/v1/add/campaign/${businessId}`, data, {
      onUploadProgress: onUploadProgress ? (progressEvent: any) => onUploadProgress(progressEvent) : undefined
    });
  }
  return httpCommon.post(`/v1/add/campaign/${businessId}`, data);
};

// Update campaign
const updateCampaign = (campaignId: number, data: any) => {
  return httpCommon.put(`/v1/update/campaign/${campaignId}`, data);
};

// Delete campaign
const deleteCampaign = (campaignPublicId: string) => {
  return httpCommon.delete(`/v1/delete/campaign/${campaignPublicId}`);
};

// Send campaign now
const sendCampaignNow = (campaignId: number, data: any) => {
  return httpCommon.put(`/v1/update/campaign/${campaignId}`, data);
};

const CampaignService = {
  getAllCampaigns,
  getCampaign,
  getCampaignStats,
  createCampaign,
  updateCampaign,
  deleteCampaign,
  sendCampaignNow
};

export default CampaignService; 